import { styled } from '@linaria/react';

import { quickBetIcon, squareIcon } from '../shared-styles';

export const OddsInfoWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 35px;
  width: 100%;
`;

export const OddsInfoWrapperTablet = styled.div<{ numberOfBookies: number }>`
  display: flex;
  align-items: center;
  height: 35px;
  min-width: calc(${props => props.numberOfBookies} * (var(--ogm-grid-cell-width-desktop) + 3px) + 5px);
`;

export const InfoSquareShortening = styled.span`
  ${squareIcon}
  background-color: var(--oc-odds-shortening);
  margin-right: 5px;
`;

export const InfoSquareDrifting = styled.span`
  ${squareIcon}
  background-color: var(--oc-odds-drifting);
  margin-right: 5px;
`;

export const InfoSquareBestOdds = styled.span`
  ${squareIcon}
  border: 2px solid var(--ogm-grid-best-odds-primary-color);
  background-color: var(--ogm-grid-best-odds-secondary-color);
  margin-right: 5px;
`;

export const OddsInfoDialogWrapper = styled.div`
  background: transparent;
  padding-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: min(calc(100vw - 60px), 350px);
`;

export const OddsInfoDialogCloseBtn = styled.button`
  position: relative;

  width: 100%;
  height: 30px;
  background: transparent;
  align-self: flex-end;

  & span {
    display: inline-block;
    width: 12px;
    height: 12px;
    top: -12px;
    position: absolute;
    right: 0;
  }
`;

export const OddsInfoCardsWrapper = styled.div`
  background: var(--oc-primary-white);
  border: 1px solid var(--oc-border);

  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
`;

export const OddsInfoCard = styled.div`
  padding: 20px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--oc-border);
  }
`;

export const OddsInfoCardHeading = styled.h4`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  & ${InfoSquareDrifting}, & ${InfoSquareShortening} {
    --oc-info-square-size: 15;
    margin-right: 10px;
    transform: translateY(-1.5px);
  }

  & .${quickBetIcon} {
    transform: translateY(-1px) scale(1.25);
    margin-right: 10px;
  }
`;

export const OddsInfoCardHeadingText = styled.span`
  color: var(--ogm-text-body);
  font-size: inherit;
`;

export const OddsInfoCardContent = styled.p`
  font-family: var(--ogm-font-family-2);
  color: var(--ogm-text-body);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
`;
